import React, { useEffect } from 'react';
import { DashboardSearchWrapper } from './DashboardSearchStyle';
import DashboardSearchHeader from './DashboardSearchHeader';
import DashboardSearchBar from './DashboardSearchBar';
import DashboardSearchRecommend from './DashboardSearchRecommend';
import authCheck from 'components/common/useAuthCheck';
import { useNavigate } from 'react-router-dom';

const DashboardSearch = () => {
   const navigate = useNavigate();

   useEffect(() => {
      const isAccessible = authCheck('CERTI');
      console.log(isAccessible);
      if (isAccessible) return;
      navigate(-1)
   }, []);

   return (
      <DashboardSearchWrapper>
         <DashboardSearchHeader />
         <DashboardSearchBar />
         <DashboardSearchRecommend />
      </DashboardSearchWrapper>
   );
};

export default DashboardSearch;
